// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"9f484c7ff46c75ec3b39","731":"50a6dabafe7d779dd9de","843":"4d22e4d87d98fa226c97","883":"19d6c4a379b04ced8257"}[chunkId] + ".js";
};